// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2s9_y","label":"CategoryService_label__2lkKb","location":"CategoryService_location__2LDTw"};